import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.object.values';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.replace';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import { assertType, assert, assertRange } from 'yaassertion';

var ENVIRONMENT = {
  PRODUCTION: "production"
};
var DOCUMENTATION_HOMEPAGE = "https://github.paypal.com/pages/Globalization-R/worldready-js/docs";
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}
var TYPES = {
  ORDINAL: "ordinal",
  CARDINAL: "cardinal"
};
var PluralFormat = /*#__PURE__*/function () {
  function PluralFormat(worldReady, options) {
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assert(isWorldReadyInstance(worldReady), "Missing worldReady object. Please read " + DOCUMENTATION_HOMEPAGE + "/about-installation#configuration for more details.");
      assertType(worldReady, "worldReady", ["object", "plain object"]);
      assertType(options, "options", ["undefined", "plain object"]);
    }
    options = options || {};
    var _options = options,
      _options$type = _options.type,
      type = _options$type === void 0 ? TYPES.CARDINAL : _options$type;
    var availableTypes = Object.values(TYPES);
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(type, "options.type", ["string"]);
      assertRange(type, availableTypes, "Invalid options.type {{value}}, expected one of {{availableTypes}}", {
        value: type,
        availableTypes: availableTypes
      });
    }
    this.type = type;
    this.globalize = worldReady.globalize;
    this.language = this.globalize.cldr.attributes.language;
    var cldr = this.globalize.cldr;
    cldr.on("get", validateCldr);
    try {
      this.pluralData = cldr.get(["supplemental", "plurals-type-" + this.type]);
    } finally {
      cldr.off("get", validateCldr);
    }
  }

  /**
   * Function that returns the plural form given a whole/decimal number.
   * @param {Number} value integer/float number whose plural form needs to be retrieved
   * @returns {String} plural form of the number
   */
  var _proto = PluralFormat.prototype;
  _proto.getPlural = function getPlural(value) {
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(value, "value", ["number"]);
    }
    return this.globalize.plural(value, {
      type: this.type
    });
  }

  /**
   * Function that returns list of plurals for a given locale & type.
   * @returns {Object} an object with following properties:
   *  - pluralCategories: an array of possible plural values for a given locale & type
   */;
  _proto.resolvedOptions = function resolvedOptions() {
    var pluralForms = this.pluralData[this.language];
    pluralForms = Object.keys(pluralForms).reduce(function (memo, form) {
      memo.push(form.replace("pluralRule-count-", ""));
      return memo;
    }, []);
    return {
      pluralCategories: pluralForms
    };
  };
  return PluralFormat;
}();

export { PluralFormat };
